import { connect } from 'react-redux'
import CandidateApplication from 'modules/Report/Partials/CandidateApplication/index.js'

import {
  cityDetails,
  tierDetails,
  collegeDetails,
  roleDetails,
  getCandidateApplicationStatus,
} from 'modules/Report/action.js'
import reportSelectors from 'modules/Report/selectors.js'
import authSelector from 'modules/Auth/selectors'
const mapStateToProps = state => ({
  cityData: reportSelectors.getCityData(state),
  tierData: reportSelectors.getTierData(state),
  collegeData: reportSelectors.getCollegeData(state),
  roleData: reportSelectors.getRoleData(state),
  rolesPublishedData: reportSelectors.getCandidateApplicationStatus(state),
  excelDataForReport: reportSelectors?.excelData(state),
  corporateData: authSelector.getCorporateData(state),
})

const mapDispatchToProps = {
  cityDetails,
  tierDetails,
  getCandidateApplicationStatus,
  collegeDetails,
  roleDetails,
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CandidateApplication)
